<template>
  <div class="second-step">
    <a-form-model :model="spiderParse" style="min-height: 400px">
      <a-collapse v-model="activeKey" expand-icon-position="right">
        <a-collapse-panel key="1" header="解析规则">
          <a-form-model-item label="选择器类型">
            <a-radio-group v-model="spiderParse.spiderParseType">
              <a-radio :value="4"> 智能解析 </a-radio>
              <a-radio :value="1"> xpath解析器 </a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="模版"  class="template-select">
            <a-select
              show-search
              :value="templateContent"
              placeholder="请输入模版名称"
              style="width: 240px"
              :default-active-first-option="false"
              :show-arrow="false"
              :filter-option="false"
              :not-found-content="null"
              @search="onTemplateContentSearch"
              @change="onTemplateContentChange"
            >
              <a-select-option v-for="d in templateContentOptions" :key="d.id">
                {{ d.templateName }}
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="解析规则">
            <a-card
              class="config-card"
              v-for="(item, index) in spiderParse.spiderParseConfig"
              :key="index"
            >
              <div slot="extra" class="card-operate">
                <span @click="handleCopyConfig(item, index)">复制</span>
                <!--<span  @click="handleAddConfig(index)">添加</span>-->
                <span
                  v-if="spiderParse.spiderParseConfig.length > 1"
                  @click="handleDeleteConfig(index)"
                >
                  删除
                </span>
              </div>
              <Rule :ruleForm="item" />
            </a-card>
          </a-form-model-item>
        </a-collapse-panel>
      </a-collapse>
    </a-form-model>
  </div>
</template>

<script>
import Rule from './Rule'
import _ from 'lodash'
import { queryTemlateListApi } from '@/api/Site/Template'
import { onHttpResponseSilent } from '@/utils/request'

export default {
  data() {
    return {
      labelCol: { span: 2 },
      wrapperCol: { span: 22 },
      activeKey: [1, 2, 3],
      templateContent: undefined,
      templateContentOptions: []
    }
  },
  props: ['spiderParse'],

  created() {
    this.onTemplateContentSearch()
  },

  methods: {
    handleCopyConfig(val, index) {
      this.spiderParse.spiderParseConfig.splice(index, 0, _.cloneDeep(val))
    },
    handleAddConfig(index) {
      this.spiderParse.spiderParseConfig.splice(index + 1, 0, {
        urls: ['baid.com'],
        parseId: 'sputniknews_news_parse_id',
        config: [
          {
            name: 'title',
            rule: ''
          },
          {
            name: 'content',
            rule: ''
          },
          {
            name: 'publisher',
            rule: ''
          },
          {
            name: 'publish_time',
            rule: ''
          },
          {
            name: 'keywords',
            rule: ''
          },
          {
            name: 'file',
            rule: ''
          }
        ]
      })
    },

    handleDeleteConfig(index) {
      this.spiderParse.spiderParseConfig.splice(index, 1)
    },

    onTemplateContentSearch(text) {
      queryTemlateListApi({ templateName: text, templateType: 1, enabled: 0, pageSize: 20 })
        .then(onHttpResponseSilent)
        .then(({ data, extra }) => {
          this.templateContentOptions = data
        })
    },

    onTemplateContentChange(value) {
      this.templateContent = value

      const tem = this.templateContentOptions.find((d) => d.id === value)
      if (!tem) {
        return
      }

      const first = this.spiderParse.spiderParseConfig[0]
      first.config?.forEach((config) => {

          let name = config.name
          if(name == 'keywords'){
            name = 'keyword'
          }else if (name == 'publish_time'){
            name = 'publisherTime'
            
          }

        if (tem[name]) {

          
          config.rule = tem[name]
        }
      })

      this.$message.success('已经成功套用模版')
    }
  },
  components: {
    Rule
  }
}
</script>

<style lang="less" scoped>
.second-step {
  margin-bottom: 50px;
}
.config-card {
  margin-bottom: 10px;
  min-height: 300px;
  &::before {
    margin-bottom: 0;
  }
}
.card-operate {
  span {
    margin-left: 20px;
    font-size: 14px;
    cursor: pointer;
    color: #1890ff;
  }
}

.template-select {
  display: inline-block;
  margin-top: -103px;
  margin-left: 400px;
}
</style>
